import { EventNames, globalEventBus } from '@littlebird/event-bus';

// One status poll per server: a dialog reopened for the same flow replaces the
// poll its dismissed predecessor left running, and sign-out ends them all
const pollsByServer = new Map<string, AbortController>();

export function runOAuthPoll<T>(
  serverId: string,
  poll: (signal: AbortSignal) => Promise<T>
): Promise<T> {
  pollsByServer.get(serverId)?.abort();
  const controller = new AbortController();
  pollsByServer.set(serverId, controller);
  return poll(controller.signal).finally(() => {
    if (pollsByServer.get(serverId) === controller) {
      pollsByServer.delete(serverId);
    }
  });
}

export function stopOAuthPoll(serverId: string): void {
  pollsByServer.get(serverId)?.abort();
}

globalEventBus.on(EventNames.AUTH_LOGOUT, () => {
  for (const controller of pollsByServer.values()) controller.abort();
});
